<template>    
    <div class="main_reports">
        <h2 class="mt-4 mb-4">Report {{report.name}}</h2>

        <div class="input_search mb-4">
            <input type="text" placeholder="Search" class="form-control">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#9F9F9F"/>
            </svg>
        </div>
        <div class="d-flex justify-content-between">
            <div>
                <button
                    @click="generatePDF()"
                    class="btn btn-border"
                    :disabled="exporting || !reportPersons.length"
                >{{ exporting ? 'EXPORTING…' : 'EXPORT' }}</button>
            </div>
            <div></div>
        </div>
        <h4 class="mt-5 mb-3">Detected</h4>
        
        <report-card-list v-for="(person, key) in reportPersons" v-show="person.isvisible"
            :item="person"
            :videos="report.videos"
            :key="key"            
        >        
        </report-card-list>
        
        <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="true"
            :paginate-elements-by-height="1100"
            :filename="exportFilename"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            :pdf-margin="10"
            pdf-orientation="portrait"
            pdf-content-width="800px"
            :html-to-pdf-options="htmlToPdfOptions"
            @progress="onProgress($event)"
            @hasDownloaded="onExported"
            ref="html2Pdf"
        >
            <section slot="pdf-content" class="exportArea">                
                    <h2 class="mt-4 mb-4">Report {{report.name}}</h2>
                    <report-card-list-export v-for="(person, key) in reportPersons" v-show="person.isvisible"
                        :item="person"
                        :videos="report.videos"
                        :key="'export_' + key"
                    ></report-card-list-export>                
            </section>
        </vue-html2pdf>
        
               

    </div>
</template>

<script>
import {bus} from '../bus';
import axios from 'axios';

import ReportCardList from "./Reports/ReportCardList";
import ReportCardListExport from "./Reports/ReportCardListExport";

import Dotscontrol from './Dotscontrol';
import iconsort from "./iconsort";
import hrdate from "./hrdate";
import statusvideo from "./statusvideo";
import VueHtml2pdf from 'vue-html2pdf';

export default {
    props: ['title_person', 'report_id'],
    data(){
        return{
            data: [],
            report: {},
            persons: [],
            visible_persons: [],
            page: 1,
            sort_name: 'up',
            sort_person: 'up',
            model_all: false,
            listdelete: [],
            visiblear: [],
            exporting: false,
            autoExportRequested: false,
        }
    },    
    methods: {
        onProgress(event) {
            console.log(`Processed: ${event} / 100`);
        },
        onExported() {
            this.exporting = false;
        },
        hasGenerated() {
            alert("PDF generated successfully!");
        },
        generatePDF() {
            if (this.exporting) return;
            if (!this.report || !this.report.id) {
                console.warn('EXPORT: report not loaded yet');
                return;
            }
            if (!this.reportPersons.length) {
                console.warn('EXPORT: no persons to export');
                return;
            }
            if (!this.$refs.html2Pdf) {
                console.warn('EXPORT: html2pdf ref missing');
                return;
            }
            this.exporting = true;
            this.$nextTick(() => {
                try {
                    this.$refs.html2Pdf.generatePdf();
                } catch (e) {
                    console.error('EXPORT failed', e);
                    this.exporting = false;
                }
                // Safety: clear spinner if download callback never fires
                setTimeout(() => { this.exporting = false; }, 60000);
            });
        },
        maybeAutoExport() {
            if (!this.autoExportRequested) return;
            if (!this.reportPersons.length) return;
            this.autoExportRequested = false;
            this.$nextTick(() => {
                setTimeout(() => this.generatePDF(), 400);
            });
        },
        addVideo(){
            bus.$emit('openpopup', {
                'open': true,
                'type': 'formuploadreport',
                'crud': 'create',
                'title_form': 'Create new report',
            })
        },
        getVisiblePersons(page = 1){            
            this.model_find = this.model_find ? this.model_find : this.model_find_prop;
            const url = `/persons`;
            let params = {
                page: page,
                countitempage: this.model_counitempage,                
                sort: this.sort,                
                sorttype: this.sorttype,
                category_id: this.category_id,
                name: this.model_find
            };            
            // params.page = this.page;
            axios.get(
                url,            
                {
                    params: params,
                    headers: {
                        'ContentType': 'application/json'
                    }
                }                
            )           
            .then((response) => {
                // handle success
                console.log('persons', response);
                this.data = response.data;
                // this.visible_persons = response.data.data;

                this.visible_persons = response.data.hasOwnProperty('current_page') ?
                    response.data.data :
                    response.data;

                console.log(".then((response) => { this.visible_persons", this.visible_persons );

                this.model_all = false;
            })
            .catch( (error) => {
                // handle error
                console.log(error);
            })
        },

        getReport(){
            const params = {                
                datatype: 'json'
            };
            axios.get('/reports/'+this.report_id, {                
                params: params,
                headers: {
                    "Content-Type": 'application/json',
                }
            }).then((response) => {                    
                    this.report = response.data;
                    console.log('fc8', response.data);
                    this.$store.commit('setReport', this.report);
                    bus.$emit('reportUpdate');
                    if(response.data.persons){
                        this.persons = response.data.persons;
                        console.log('this.persons from get report: ', this.persons);
                    }
                    this.maybeAutoExport();
            })
            .catch( (error) => {
                // handle error
                console.log(error);
            })
        },
        sortName(){

            if(this.sort_name === 'up'){
                this.sort_name = 'down';
            }else{
                this.sort_name = 'up';
            }

        },
        sortPerson(){

            if(this.sort_person === 'up'){
                this.sort_person = 'down';
            }else{
                this.sort_person = 'up';
            }

        },
        checkAll(){
            if(this.model_all){
                this.listdelete = [];
                this.data.map((item, key) => {
                    item.checked = true;
                    this.listdelete.push(item.id);
                });
            }else{

                this.listdelete = [];
                this.data.map((item, key) => {
                    item.checked = false;
                });
                console.log('done');
            }
        },
        changeItem(i){
            this.listdelete = [];
            this.data.map((item, key) => {
                if(item.checked){
                    this.listdelete.push(item.id);
                }
            });
        }
    },
    watch: {

    },
    mounted(){
        const params = new URLSearchParams(window.location.search || '');
        this.autoExportRequested = params.get('export') === '1';
        this.getReport();
        this.getVisiblePersons();
        console.log('fc4_report', this.report);
        console.log('fc_report', this.report);


        console.log('fc6_this.persons', this.persons);
        console.log('fc7_this.reportPersons', this.reportPersons);                
    },
    computed: {
        exportFilename(){
            const name = (this.report && this.report.name) ? String(this.report.name) : 'report';
            return name.replace(/[\\/:*?"<>|]+/g, '_').slice(0, 120) || 'report';
        },
        htmlToPdfOptions(){
            return {
                margin: [10, 10, 10, 10],
                filename: `${this.exportFilename}.pdf`,
                image: { type: 'jpeg', quality: 0.98 },
                enableLinks: false,
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    allowTaint: true,
                    backgroundColor: '#ffffff',
                    logging: false,
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'a4',
                    orientation: 'portrait',
                },
            };
        },
        reportPersons(){
            this.persons.map((item) => {
                item.checked = false;
                item.isvisible = true;
            });
            return this.persons;
        },
        // Alias kept for any leftover references / console debugging
        reportsItem(){
            return this.reportPersons;
        },
        reportVisiblePersons(){
            this.visible_persons.map((item) => {
                item.checked = false;
                item.isvisible = true;
            });
            console.log('reportVisiblePersons() this.visible_persons: ', this.visible_persons);
            
            return this.visible_persons;
        }
    },
    components: {
        VueHtml2pdf,
        ReportCardList,
        ReportCardListExport,
        Dotscontrol,
        iconsort,
        hrdate,
        statusvideo        
    }
}
</script>

<style lang="scss" scoped>
    /* Printable PDF root: white page, dark text. Child export cards are light-themed. */
    .exportArea {
        background-color: #fff !important;
        color: #111 !important;
        padding: 20px;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    .exportArea h2 {
        color: #111 !important;
    }

</style>
